<app-filter-item
  *ngFor="let filterItem of filterItems"
  [filterItem]="filterItem"
  (filterToggled)="onFilterToggled($event)">

</app-filter-item>
